import { useEffect } from "react";
import Button from "./Button.jsx";

const ProgressBar = ({ header, onClose, progress, done, button, fn }) => {
  return (
    <div className="absolute z-50 top-[25%] left-[15%] w-[60%] h-[250px] bg-[#1F2937CC] shadow-lg rounded-md backdrop-blur-[10px] flex flex-col">
      
      {/* Header */}
      <div className="flex justify-between items-center px-3 py-1">
        <span className="font-bold text-xl">{done ? "Dokončeno" : "Nahrávání souboru"}</span>
        <div className="flex gap-2">
          {header?.map((btn, idx) => (
            <button
              key={idx}
              onClick={btn.action === "close" ? onClose : undefined}
              className={`px-2 py-1 rounded ${btn.action ? 'cursor-pointer hover:bg-white/20' : 'cursor-not-allowed opacity-50'}`}
            >
              <img src={btn.icon} alt="" className="w-6 h-6" />
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="flex flex-col items-center justify-center flex-1 px-6">
        <div className="relative w-full bg-gray-300 h-12 rounded-full overflow-hidden p-2">
          <div
            className="h-full rounded-full transition-all duration-150"
            style={{ width: `${progress}%`, background: "linear-gradient(90deg, #02A0DB, #016C9B)" }}
          />
          <span
            className={`absolute inset-0 flex items-center justify-center text-base font-semibold transition-colors duration-300 ${progress < 50 ? "text-gray-800" : "text-white"}`}
          >
            {done ? "Dokončeno" : `${progress}%`}
          </span>
        </div>

        {/* Button z controlleru */}
        {done && button && (
          <div className="w-full flex justify-end mt-4">
            <Button {...button} onClick={() => fn.handleAction(button.action)} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgressBar;
